<template>
  <div>
    <div class="content_box">
      <div class="line"></div>
      <div class="title_text">进度查询</div>
    </div>
    <div class="content_boxs">
      <el-row :gutter="10">
        <el-col :xs="24" :sm="24" :md="24" :lg="14" :xl="14"
          ><div class="grid-content bg-purple padding">
            <div class="content_box_title">
              <div class="circle_l"></div>
              <div class="circle_r"></div>
              <div class="text_xl">运输中</div>
            </div>
            <div
              class="step_box"
              v-for="(item, index) in logisticsData"
              :key="index"
            >
              <div class="step_box_right">
                <div class="step_box_title">
                  <div>批次号：{{ item.name }}</div>
                  <div
                    v-if="
                      item.deliverprogressDtos != '' && item.deliverprogressDtos
                    "
                  >
                    {{ item.deliverprogressDtos[0].description }}
                  </div>
                </div>
                <el-steps :active="item.stage" align-center>
                  <el-step title="集货中"></el-step>
                  <el-step title="装车发货"></el-step>
                  <el-step title="已起航"></el-step>
                  <el-step title="清关中"></el-step>
                  <el-step title="分拣中"></el-step>
                  <el-step title="等待取货"></el-step>
                  <el-step title="等完成"></el-step>
                </el-steps>
              </div>
              <el-divider direction="vertical"></el-divider>
              <i
                class="el-icon-arrow-right"
                @click="details(item.id, item.name, item)"
              ></i>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="10" :xl="10"
          ><div class="grid-content bg-purple-light padding">
            <div class="content_box_title">
              <div class="circle_l"></div>
              <div class="circle_r"></div>
              <div class="text_xl">集货中</div>
            </div>
            <div>
              <el-row :gutter="20">
                <el-col
                  v-for="(item, index) in orderData.content"
                  :key="index"
                  :xs="24"
                  :sm="24"
                  :md="24"
                  :lg="24"
                  :xl="12"
                  ><div class="grid-content bg-purple">
                    <div class="right_box_l">
                      <!-- :color="
                          item.deliverprogressDtos.length * 20 == 100
                            ? '#87A2FF'
                            : item.deliverprogressDtos.length * 20 == 80
                            ? '#FF9253'
                            : '#F3F3F3' -->
                      <!-- " -->
                      <div class="text_ko">批次号：{{ item.name }}</div>
                      <el-progress
                        :stroke-width="15"
                        stroke-linecap="butt"
                        type="circle"
                        class="circle_boxs"
                        :percentage="
                          item.totalWeightKg > item.targetweightkg
                            ? 100
                            : item.totalWeightKg / item.targetweightkg
                            ? (
                                item.totalWeightKg / item.targetweightkg
                              ).toFixed(2) * 100
                            : 0
                        "
                      ></el-progress>
                      <div
                        class="text_ko text_wight"
                        v-if="
                          item.deliverprogressDtos != '' &&
                          item.deliverprogressDtos
                        "
                      >
                        {{
                          item.deliverprogressDtos[
                            item.deliverprogressDtos.length - 1
                          ].name
                        }}
                      </div>
                      <img
                        @click="details(item.id, item.name, item)"
                        class="arrows_img"
                        src="../../assets/img/img2.png"
                        alt=""
                      />
                    </div></div
                ></el-col>
              </el-row>
            </div></div
        ></el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import crudDept from "@/api/userMG";
import Cookies from "js-cookie";
import Config from "@/settings";
export default {
  data() {
    return {
      activeName: "first",
      dialogVisible: false,
      orderData: [],
      screen: {
        page: 1,
        size: 50,
        routetype: 1,
        aeronumber: "",
        name: "",
      },
      logisticsData: [],
    };
  },
  created() {
    this.orderList();
    this.getBatchsAndExpress();
  },
  methods: {
    //查询批次详情
    details(e, title, item) {
      localStorage.setItem("batch", JSON.stringify(item));
      // this.$router.push({ path: "/logistics/logistics" });
      this.$router.push({
        path:
          "/extractGoods/details?id=" +
          e +
          "&name=航班查询" +
          "&title=" +
          title,
      });
    },
    //集货中批次物流
    getBatchsAndExpress() {
         var logistics_user = JSON.parse(Cookies.get("logistics_user"));
      var data = {
        page: 1,
        size: 50,
        routetype: 1,
        grouptype: 40,
        stages: "2,3,4,5,6",
        createdbyid:logistics_user.id
        // type: 101,batch
      };
      crudDept.getBatchsAndExpress(data).then((res) => {
        this.logisticsData = res.content;
        //console.log(this.logisticsData);
      });
    },
    //运输中批次集货中
    orderList() {
      var data = {
        page: 1,
        size: 50,
        routetype: 1,
        grouptype: 40,
        stage: 1,
      };
      crudDept.getBatchsAndExpress(data).then((res) => {
        this.orderData = res;
      });
    },
    //批次列表
    // orderList() {
    //   crudDept.batch(this.screen).then((res) => {
    //     this.orderData = res;
    //   });
    // },
    //查看批次详情
    toDetails() {
      //console.log("llll");
      this.$router.push({ path: "/flight/batchDetails" });
    },
  },
};
</script>
<style scoped>
.arrows_img {
  margin-top: 18px;
  display: block;
  margin: 0 auto;
}
.el-icon-arrow-right {
  margin-right: 34px;
}
.el-divider--vertical {
  height: 100% !important;
}
.el-divider {
  background-color: #c5d1ff !important;
}
.step_box_right {
  width: 90%;
}
.step_box_title {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 21px;
  color: #5178ff;
  opacity: 1;
  padding-left: 34px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  margin-bottom: 17px;
}
.step_box >>> .el-step.is-horizontal .el-step__line {
  height: 6px !important;
  background-color: #fff !important;
  border-color: #a5b8fc !important;
  border: 1px solid #a5b8fc !important;
  top: 7px;
}
.step_box >>> .el-step__head.is-wait {
  color: #a5b8fc;
}
.step_box >>> .el-step__line-inner {
  border: none !important;
  border-style: solid !important;
}
.step_box >>> .el-step__head.is-process {
  color: #a5b8fc;
  border-color: #a5b8fc;
}
.step_box >>> .el-step__title.is-wait {
  color: #a5b8fc;
}
.step_box >>> .el-step__title.is-process {
  color: #a5b8fc;
}
.step_box >>> .el-step__head.is-finish {
  color: #85a0ff !important;
  border-color: #85a0ff !important;
}
.step_box >>> .el-step__title.is-finish {
  color: #85a0ff !important;
}
.el-step.is-horizontal .el-step__line {
}
.step_box >>> .el-step__icon.is-text {
  border: 4px solid !important;
}
.step_box >>> .el-step__icon-inner {
  color: #fff !important;
}
.content_box_title {
  margin-bottom: 32px;
}
.step_box:hover {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.step_box {
  margin-bottom: 21px;
  height: 118px;
  background: #f5f7ff;
  opacity: 1;
  padding: 22px 0;
  box-sizing: border-box;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.grid-content {
  background: #ffffff;
}
.content_box {
  width: 100%;
  height: 93px;
  background: #ffffff;
  padding: 0 58px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
}
.grid-content {
  width: 100%;

  box-sizing: border-box;
  background: #ffffff;
}
.padding {
  padding: 22px 58px;
  box-sizing: border-box;
}
.bgc {
  background-color: transparent !important;
}
.line {
  width: 4px;
  height: 24px;
  background-color: #5178ff;
  border-radius: 20px;
}
.title_text {
  font-size: 25px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 36px;
  color: #333333;
  margin-left: 10px;
}
.right_box_l {
  width: 100%;
  height: auto;
  box-shadow: 0px 0px 6px rgba(3, 55, 159, 0.16);
  opacity: 1;
  border-radius: 20px;
  padding: 30px;
  box-sizing: border-box;
  text-align: center;
  margin-bottom: 20px;
}
.right_box_l:hover {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.text_ko {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 21px;
  color: #333333;
}
.circle_boxs {
  margin: 18px auto;
}
.text_wight {
  font-weight: normal !important;
}
</style>


// WEBPACK FOOTER //
// src/views/flight/flight.vue